module.exports = __webpack_public_path__ + "img/DSCN1919.82bdbb19.jpg";